import { render, staticRenderFns } from "./ItemOriginalSource.vue?vue&type=template&id=9c976214"
import script from "./ItemOriginalSource.vue?vue&type=script&lang=js"
export * from "./ItemOriginalSource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports